module.exports = __webpack_public_path__ + "assets/img/transition_comeback.bd77a2c1.png";